import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.89.018a.871.871 0 0 0-.607 1.497L5.766 7 .283 12.485a.872.872 0 1 0 1.232 1.233l5.484-5.485 5.485 5.486a.87.87 0 1 0 1.232-1.233L8.23 7l5.485-5.485A.872.872 0 1 0 12.484.282L6.999 5.768 1.515.282A.87.87 0 0 0 .89.018" }, null, -1)
  ])))
}
export default { render: render }